// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__Fy8Ck","header":"ReportDetails_header__nxN-U","title":"ReportDetails_title__3-dPy","left":"ReportDetails_left__3V0ZH"};